import { useState } from "react";

export interface InviteUserForm {
  email: string;
  role: "admin" | "member";
}

const defaultForm: InviteUserForm = {
  email: "",
  role: "member",
};

export function useInviteUserForm() {
  const [form, setForm] = useState<InviteUserForm>(defaultForm);

  const updateField = (field: keyof InviteUserForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const resetForm = () => {
    setForm(defaultForm);
  };

  const isValid = form.email.trim().length > 0;

  return {
    form,
    updateField,
    resetForm,
    isValid,
    setEmail: (email: string) => updateField("email", email),
    setRole: (role: "admin" | "member") => updateField("role", role),
  };
}
